export default __webpack_public_path__ + "static/media/selectExtensionsIcon.cf96d8c7.png";